import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask',
})
export class PhoneMaskPipe implements PipeTransform {
  transform(value: string) {
    const m = value.match(/-\d{4}$/);
    if (m) {
      return `(***) ***${m[0]}`;
    }
    return value;
  }
}
